import { render } from "./FinderStep5.vue?vue&type=template&id=9f1afcda"
import script from "./FinderStep5.vue?vue&type=script&lang=js"
export * from "./FinderStep5.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\vscode_playground\\WeinfinderV3\\weinfinder\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__